var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBestSeller(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 12 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 4.50006H2.5V10.5001H1C0.867392 10.5001 0.740215 10.4474 0.646447 10.3536C0.552678 10.2598 0.5 10.1327 0.5 10.0001V5.00006C0.5 4.86745 0.552678 4.74027 0.646447 4.6465C0.740215 4.55273 0.867392 4.50006 1 4.50006ZM3.6465 3.85356L6.8465 0.653556C6.88903 0.610903 6.94553 0.585039 7.00561 0.580722C7.06569 0.576404 7.12531 0.593923 7.1735 0.630056L7.6 0.950056C7.71845 1.03898 7.80792 1.16098 7.85713 1.30068C7.90633 1.44038 7.91308 1.59153 7.8765 1.73506L7.3 4.00006H10.5C10.7652 4.00006 11.0196 4.10541 11.2071 4.29295C11.3946 4.48049 11.5 4.73484 11.5 5.00006V6.05206C11.5001 6.18274 11.4747 6.31218 11.425 6.43306L9.8775 10.1906C9.83975 10.2822 9.77563 10.3605 9.69329 10.4156C9.61094 10.4707 9.51408 10.5001 9.415 10.5001H4C3.86739 10.5001 3.74021 10.4474 3.64645 10.3536C3.55268 10.2598 3.5 10.1327 3.5 10.0001V4.20706C3.50003 4.07446 3.55273 3.9473 3.6465 3.85356Z",
    fill: "#1D474F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBestSeller);
export default __webpack_public_path__ + "static/media/best_seller.5f7ebfdc529b2c22fb362ee463767155.svg";
export { ForwardRef as ReactComponent };